/**
 * 把 PNG dataURL 保存到系统相册。
 * - APK(Cordova WebView)：调用原生 SaveImage 插件，写入 相册/Pictures 下的「江苏智慧人社」目录
 * - 普通浏览器：退化为 <a download> 触发下载
 *
 * @param {string} dataUrl canvas.toDataURL('image/png') 的结果
 * @param {string} fileName 保存文件名（含 .png）
 * @returns {Promise<{mode:'app'|'browser'}>} APP 内插件不可用/失败时 reject，由调用方做长按兜底
 */
export default function saveDataUrlToGallery(dataUrl, fileName) {
  return new Promise((resolve, reject) => {
    if (window.cordova && typeof window.cordova.exec === 'function') {
      window.cordova.exec(
        () => resolve({ mode: 'app' }),
        err => reject(new Error(typeof err === 'string' ? err : '原生保存失败')),
        'SaveImage',
        'saveImage',
        [dataUrl, fileName]
      )
    } else {
      const link = document.createElement('a')
      link.download = fileName
      link.href = dataUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      resolve({ mode: 'browser' })
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/saveToGallery.js